import React from "react";
import PropTypes from "prop-types";
import { Dot } from "../Dot";

import styles from "./SliderIndicator.scss";

export const SliderIndicator = ({
  amount,
  activeIndex,
  onActivate,
  ...restProps
}) => {
  const indicators = [];

  for (let i = 0; i <= amount - 1; i += 1) {
    indicators.push(
      <Dot
        className={styles.indicator}
        active={i === activeIndex}
        onClick={() => onActivate(i)}
        key={`slider-indicator-${i}`}
      />
    );
  }

  return (
    <div className={styles.sliderIndicator} {...restProps}>
      {indicators}
    </div>
  );
};

SliderIndicator.defaultProps = {
  activeIndex: 0,
  onActivate: () => {},
};

SliderIndicator.propTypes = {
  amount: PropTypes.number.isRequired,
  activeIndex: PropTypes.number,
  onActivate: PropTypes.func,
};

SliderIndicator.displayName = "SliderIndicator";

export default SliderIndicator;
